module.exports = __webpack_public_path__ + "static/img/townsend.21a998e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/townsend.jpg
// module id = zRGT
// module chunks = 1